import { FCC, H5 } from "@dgs/core";
import { useId } from "react";
import styled from "styled-components";

interface Props {
	title: string;
}

const StyledTitle = styled(H5)`
	margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

export const TitledSection: FCC<Props> = ({ title, children }) => {
	const titleId = useId();

	return (
		<section aria-labelledby={titleId}>
			<StyledTitle id={titleId}>{title}</StyledTitle>
			{children}
		</section>
	);
};
